import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import CompCardContext from "../../context/comp-card/CompCardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import ActionMenu from "../layout/ActionMenu";
import Preloader from "../layout/Preloader";
import DataTable from "../common/DataTable";
import SearchMenu from "../common/SearchMenu";
import moment from "moment";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const CompCardManagement = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const { loaded, getConfigValue, getConfigValueByCode } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const cardContext = useContext(CardContext);
  const { isLoading, loadCard } = cardContext;
  const compCardContext = useContext(CompCardContext);
  const navigationContext = useContext(NavigationContext);
  const { compCards, getCompCards, compCardsLoading, resetCompCardState } =
    compCardContext;
  const { navigationBack, resetNavigationState } = navigationContext;
  const history = useHistory();
  let compCardData;
  // pages;
  if (compCards) {
    compCardData = compCards.data;
    // pages = {
    //   numberOfPages: compCards.numberOfPages,
    //   pageNumber: compCards.pageNumber,
    //   numberOfRecords: compCards.numberOfRecords,
    // };
  }

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Account Metro Q Cards",
  });

  const [searchCriteria, setSearchCriteria] = useState({
    filterType: "",
    filterValue: "",
  });
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    console.log("checking navigation", navigationBack);
    if (navigationBack) {
      resetNavigationState();
    } else {
      console.log("RESETing");
      resetCompCardState();
    }
    if (loaded) {
      const pageSize = getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      setPageSize(pageSize);
    }
    //eslint-disable-next-line
  }, []);

  //   const { filterType, filterValue } = searchCriteria;

  const loadPageData = async (pageNo, criteria) => {
    try {
      console.log("###Criteria: ", searchCriteria);
      const res = await getCompCards({ ...criteria, pageNo }, token);
      console.log("$$RES: ", res);
      if (res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      } else if (res.length === 0) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 469);
        setAlert(msg, "warning");
      } else {
        setTableAlert(
          "Search is successfully completed and matching records are displayed in the table"
        );
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };
  // const getCurrentCompCard = (compCard) => {
  //   console.log("$$$COMPCARD filter:", compCard);
  //   const compCardItem = compCardData.filter(
  //     (item, index) => index === compCard
  //   )[0];
  //   console.log("$$$COMPCARD filtered Item:", compCardItem);
  //   if (compCardItem) {
  //     console.log("$$$COMPCARD filter ID:", compCardItem.id);
  //     return compCardItem;
  //   } else {
  //     console.log("$$$NULL ID:");
  //     return null;
  //   }
  // };
  const { hasTokenExpired } = useTokenCheck();
  //setCurrentCard
  const selectCurrentCard = async (card) => {
    await hasTokenExpired();
    try {
      console.log("Load Card", card);
      await loadCard({ cardnumber: card }, token);
      history.push("/home/mycard-details");
    } catch (err) {
      clearAlerts();
      console.log("###ERROR:", err);
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const getFormattedObject = (cards) => {
    if (!cards) return [];
    return cards.map((card) => {
      return {
        ...card,
        expirationDate: moment
          .utc(card.expirationDate)
          .tz(env.REACT_APP_HMW_TIME_ZONE)
          .format("MM/DD/YYYY hh:mm A"),
      };
    });
  };

  const onSearchCompCards = async (criteria) => {
    setTableAlert(" ");
    console.log("###Criteria: ", criteria);
    const { filterType, filterValue } = criteria;
    let searchCriteria = {};

    searchCriteria = {
      filterType: filterType,
    };
    if (filterValue !== "") {
      searchCriteria = {
        ...searchCriteria,
        filterValue,
      };
    }
    setSearchCriteria((prevCriteria) => ({
      ...prevCriteria,
      ...searchCriteria,
    }));
    // setSearchCriteria({ ...searchCriteria });
    // console.log("$$Criteria: ", filterCriteria);
    console.log("$$$Criteria: ", searchCriteria);
    loadPageData(0, searchCriteria);
  };

  const searchByList = [
    {
      name: "cardNumber",
      displayName: "Card Number",
      requireInput: true,
    },
  ];

  const columnDefs = [
    {
      Header: "Card Number",
      accessor: "cardNumber",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentCard(value);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Profile Name",
      accessor: "profileName",
    },
    {
      Header: "Status",
      accessor: "status",
      filter: "text",
    },
    {
      Header: "Expires On",
      accessor: "expirationDate",
    },
  ];

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {(compCardsLoading || isLoading) && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="patronPage__titleBar">
          <h1 id="pageHeader" className="patronPage__pageTitle">
            ACCOUNT METRO Q CARDS
            <div id="pageHeaderDesc" className="patronPage__pageTitle__desc">
              METRO Q CARDS that are associated with your account.
            </div>
          </h1>
        </div>
        <div className="patronPage__content">
          <div className="patronPage__searchBar">
            <SearchMenu
              onSearch={onSearchCompCards}
              searchByList={searchByList}
              includePeriod={false}
            />
          </div>
          <div
            aria-live="polite"
            style={{ color: "transparent", height: "1px" }}
          >
            {tableAlert}
          </div>
          {compCardData && compCardData.length > 0 && (
            <div className="patronPage__tableListing">
              <DataTable
                data={getFormattedObject(compCards.data)}
                columnDefs={columnDefs}
                pageSize={pageSize}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CompCardManagement;
